import { FC } from 'react'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ContentLayout } from 'components/Layouts'
import { getUserData } from 'redux/reducers/users'
import { BackToPremiumsBreadcrumb } from 'containers/Premiums/components/BackToPremiumsBreadcrumb'
import { OnlinePayments } from './OnlinePayments'
import { PostedPayments } from './PostedPayments'

import classes from './PremiumsHistory.module.scss'
import { Component } from '@cms-max/medicare-api-sdk'

export const PremiumsHistory: FC = () => {
  const { t } = useTranslation('premiumsHistory')
  const userData = useSelector(getUserData)
  const userFullName = `${userData.user?.firstName} ${userData.user?.middleName} ${userData.user?.lastName}`

  return (
    <ContentLayout
      className="ds-u-padding-bottom--7"
      heading={t('heading')}
      width="wide"
      withPrintButton
      printComponent={Component.Premiums}
      nav={<BackToPremiumsBreadcrumb />}
    >
      <>
        <div className={classNames('ds-l-container ds-u-padding-bottom--3', classes.userFullName)}>
          {t('name')}: <span className='ds-u-font-weight--semibold'>{userFullName.toUpperCase()}</span>
        </div>
        <div>
          <OnlinePayments />
        </div>
        <div className='ds-u-margin-top--3'>
          <PostedPayments />
        </div>
      </>
    </ContentLayout>
  )
}
